import { styled } from 'styled-components';
import { OptionItem } from '../options-block/styles';

const BoxCondition = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: auto;
`;
const ConditionItem = styled(OptionItem)`
  cursor: auto;
  padding: 12px;
`;

export { BoxCondition, ConditionItem };
